<template>
  <div class="event">
    <div class="event__head">
      <div 
        v-if="iconCode"
        class="event__icon"
        :style="`
        mask: url(data:image/svg+xml;base64,${iconCode})
        no-repeat center; mask-size: contain;`"
      ></div>
      <div class="event__metadata">
        <div class="event__metadata-top">
          {{ formattedDateTime }} - {{ data.properties.name }}
        </div>
        <a
          v-if="data.geometry"
          class="event__link" @click.prevent="panAndShowModalForEvent(data.geometry)"
          title="">
          <translated-text-component translation="modal_show_on_map" />
        </a>
      </div>
    </div>
    <div class="event__details">
      <div class="event__content" v-html="data.properties.description"></div>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, ref, toRaw, toRefs } from 'vue';
import { format, parseISO }               from 'date-fns';
import EventIconModalService             from '@/services/EventIconModalService';
import { IEventData }                     from '@/interfaces/IEventData';
import store                              from '@/store/index';
import { IModalData } from '@/services/layers/IModalData';
import EventIconMapperService from '@/services/EventIconMapperService';
import MapIconsGeneratorService from '@/services/MapIconsGeneratorService';

const Event: object = defineComponent({
  name: 'Event',
  props: {
    data: {
      name: 'data',
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const eventData = toRaw(props.data.properties);
    const {coordinates} = toRaw(props.data.geometry);
    const formattedDateTime = computed(() => {
       if (eventData.start_time) {
        return format(parseISO(eventData.start_time), 'yyyy-MM-dd HH:mm');
       }
       return '';
    });

    const {eventCategories} = store.state;
    const eventCateogory = eventCategories.find((category: any) => category.key === eventData.category.event_code);
    const iconCode = eventCateogory && eventCateogory.icon_code ? eventCateogory.icon_code : null;

    // const iconCode = MapIconsGeneratorService.resolveIconUrl(props.data.properties.category.event_code, true);

    const panAndShowModalForEvent = (geometry: any) => {
      store.commit('closeEventListModal');
      // to show all event markers on the map
      store.commit('enableEventLayers');

      store.state.leafletMapInstance.flyTo({
        lat: coordinates[1],
        lng: coordinates[0],
      }, 17);

      const modalData: IModalData = {
        title: eventData.name,
        content: eventData.description,
        navigationPoint: undefined,
        lastUpdate: eventData.update_time,
        icon: MapIconsGeneratorService.resolveIconUrl(iconCode, true),
        templateName: 'TemplateModalEvent',
        customClassName: 'modal--event',
        metaData: eventData,
      };
      store.commit('displayModal', modalData);
    };

    return {
      iconCode,
      formattedDateTime,
      panAndShowModalForEvent,
    };
  },
});
export default Event;
</script>

<style scoped lang="scss">


.event {
  font-size: rem(16px);
  letter-spacing: rem(0.7px);
  border-radius: rem(9px);
  background-color: $main-bg-color;
  box-shadow: 0 2px 5px 0px rgb(0 0 0 / 19%);
  padding-left: rem(32px);
  padding-right: rem(20px);
  padding-top: rem(18px);
  padding-bottom: rem(20px);
  position: relative;
  overflow: hidden;
  border: 1px solid $main-font-color;

  &__icon {
    width: 40px;
    height: 50px;
    background-color: currentColor;
  }

  .dark-theme & {
    border: 1px solid $static_orange;
  }

  &::before {
    position: absolute;
    content: '';
    height: 100%;
    top: 0;
    left: 0;
    width: rem(14px);
    background-color: $event-ribbon-bg;
  }

  &:not(:last-of-type) {
    margin-bottom: rem(20px);
  }

  &__head {
    display: flex;
    align-items: center;
    margin-bottom: rem(16px);
  }

  &__icon {
    width: rem(40px);
    min-width: rem(40px);
    margin-right: rem(20px);
    align-self: flex-start;

    img {
      max-width: 100%;
    }
  }

  &__metadata {
    font-size: rem(16px);
    font-weight: 700;

    &-top {
      margin-bottom: rem(3px);
    }
  }

  &__details {
    font-size: rem(12px);
    line-height: 1.4;
  }

  &__link {
    color: $event-ribbon-bg;
    text-decoration: underline;
    font-size: rem(12px);
  }
}
</style>
